export default __webpack_public_path__ + "static/chrome_share-539bed769c26d72ae80ed0a2bf0ba401.png";